<template>
	<div>
		<b-modal :id="idModal" size="sm" modal-class="custom-dialog"
    hide-footer no-close-on-backdrop :title="!searchOnTab ? $t('Multibúsqueda') : $t('Multiselección de envíos')">
			<div class="mt-0">
				<form-render :key="keyFormRender" :fields="fields" :form.sync="form" ref="formRenderMultiSearch" containerButtonsClass="col-sm-12" /> 
        <span><b>Total de envíos : {{ totalDlvToSearch }} </b></span>
        <div class="d-flex justify-content-end">
          <b-button class="m-1" variant="warning" @click="ok" :disabled="loading.filter || disableButton">
            <b-spinner v-if="loading.filter" small/>
            <span class="mb-1">{{ !loading.filter ? $t('Buscar') : ''}}</span>
          </b-button>
        </div>
			</div>
		</b-modal>
	</div>
</template>

<script>

export default {
  props: ['filter', 'id', 'searchOnTab'],
  data () {
    return {
      form: {},
      fields: [],
      keyFormRender: 0,
      loading: { filter: false },
      idModal: 'modalMultiSearch',
      disableButton: true
    }
  },
  mounted () {
    this.setInitialData()
  },
  methods: {
    setInitialData () {
      if (this.id) this.idModal = this.id
      this.fields = [
        {fieldType: 'FieldTextarea', name: 'ids', label: !this.searchOnTab ? 'Agregue o pegue los envíos/devoluciones que desea buscar separados por una \'coma\' o un \'enter\'' : 'Agregue o pegue los envíos que desea buscar separados por una \'coma\' o un \'enter\'', containerClass: 'col-sm-12 container-info', rows: 5, placeholder: '' }
      ]
    },
    resetForm () {
      this.loading.filter = false
      this.form = {}
      this.disableButton = true
      this.$bvModal.hide('modalMultiSearch')
    },
    ok() {
      this.loading.filter = true
      this.disableButton = true
      const ids = this.form?.ids || ''
      const deliveries = ids.split(/[,|\n]/).map(el => el.trim()).filter(el => el)
      // const deliveries = this.form.ids.split(/[,|\n]/).map(el => el.trim()).filter(el => el)
      const deliveriesString = deliveries.join(',')
      const filter = { number: deliveriesString, qty: deliveries.length }
      this.$emit('filter', filter)
    }
  },
  watch: {
    'form.ids' () {
      this.form.ids ? this.disableButton = false : this.disableButton = true
    }
  },
  computed: {
    totalDlvToSearch () {
      if (this.form.ids) {
        const deliveries = this.form.ids.split(/[,|\n]/).map(el => el.trim()).filter(el => el)
        return deliveries.length
      } else {
        return 0
      }
    }
  }
}
</script>
<style>

</style>
